import { useContext } from 'react';
import styles from './HearingAidSearch.module.scss';
import HearingAidImage from '../../assets/images/Hearing Icon.png';
import { AppContext } from '../../context/AppContext';
import { useHistory } from 'react-router-dom';
import { RouteWithState } from '../../lib/util';
import { EarIcon } from '../icons/Icons';

const HearingAidSearch = () => {
  const appContext = useContext(AppContext);
  const { planCode, chosenSpecialty, location, name, directoryListType, isDisabled, distance } = appContext;
  const history = useHistory();

  return (
    <>
      <div className={styles.hearingAidContainer}>
        {/* <div>
          <EarIcon width={'64px'} height={'64px'} isActive={true} />
        </div> */}
        <div>
          <p>
            You have a <b>supplemental hearing aid benefit </b> that gives you everything you need to manage your hearing health. Your benefit includes an annual hearing test, choice of hearing aids, follow-up visits, and a 60-day guarantee.
          </p>
          <p>
            <b>To access your benefit, contact NationsHearing<sup>&#174;</sup>:</b>
          </p>
          <ul>
            <li>
              <b>Call 844-617-3350 (TTY:711)</b> to speak with a Member Experience Advisor who will schedule your hearing test with a local hearing aid provider
            </li>
            <li>
              Or visit <a href='https://nationshearing.com/simpra' target='_blank' rel='noreferrer'>
              nationshearing.com/simpra
                </a> to find a local provider
            </li>
          </ul>

          <p>
            See your plan's <a href='https://simpra.com/for-members/plan-documents' target='_blank' rel='noreferrer'>Evidence of Coverage</a> for full benefit details.
          </p>
          <p>
            Download the <a href='https://simpra.com/wp-content/uploads/2026/05/SIMPAD-HEAR-FLY-FAQ-2026-EN-R4.pdf' target='_blank' rel='noreferrer'>
                NationsHearing<sup>&#174;</sup> FAQs 
                </a> for more information.
          </p>

          <p>
            &copy;2026 NationsBenefits, LLC. All rights reserved. NationsHearing is a registered trademark of NationsBenefits, LLC. Other marks are the property of their respective owners.
          </p>
        </div>
        
      </div>
    </>
  );
};

export default HearingAidSearch;
